import React from 'react'
import PropTypes from 'prop-types'

const NewsLetter = () => {
  return (
    <section id="newsletter" className="px-6 py-10 lg:px-0 lg:py-20 xl:py-[88px]">
      <div className="relative lg:w-[912px] xl:w-[994px] bg-[#003DA6] m-auto left-0 right-0 py-[88px]">
        <IlustrationLeft className="absolute top-4 left-4 w-14 h-14 lg:top-6 lg:left-6 lg:w-[109px] lg:h-[109px]"/>
        <IlustrationRight className="absolute bottom-4 right-4 w-14 h-14 lg:bottom-6 lg:right-6 lg:w-[109px] lg:h-[109px]"/>

        <h1 className=" text-white text-[18px] lg:text-[28px] font-bold leading-[150%] lg:w-[595px] text-center m-auto left-0 right-0">Sign up for newsletter to receive special offers, news and more! 👋</h1>

        <form action="#" className="m-auto left-0 right-0 w-fit mt-8 flex flex-col gap-y-4 lg:flex-row gap-x-2">
          <input className="w-[276px] h-[40px] border border-[#EAEBEF] bg-[#003DA6] text-[#969FB6] text-sm py-[9px] px-3" type="text" placeholder="Your email address ..."/>
          <button type="button" className="w-full lg:w-[116px] h-[39px] bg-white text-[#003DA6] text-sm font-bold">Subscribe</button>
        </form>
      </div>
    </section>
  )
}

const IlustrationLeft = ({ className }) => {
  return (
    <svg className={className} width="109" height="109" viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="76" height="76" fill="white"/>
      <rect x="76" y="76" width="33" height="33" fill="#DEE9FF"/>
    </svg>
  )
}

const IlustrationRight = ({ className }) => {
  return (
    <svg className={className} width="109" height="109" viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="33" y="33" width="76" height="76" fill="white"/>
      <rect width="33" height="33" fill="#DEE9FF"/>
    </svg>
  )
}

IlustrationLeft.propTypes = {
  className: PropTypes.string
}

IlustrationRight.propTypes = {
  className: PropTypes.string
}

export default NewsLetter
